import React from "react";
import style from "./style.module.css";

export interface IVideoProps {
    videoSrc: string
}

export function Video(props: IVideoProps) {
    return (
        <section className={style.videoWrapper}>
            <iframe
                title="Team TMI Video"
                className={style.embed}
                src={props.videoSrc} 
                width="640" 
                height="360" 
                frameBorder="0" 
                allow="autoplay; fullscreen; picture-in-picture" 
                allowFullScreen
            />
        </section>
    );
}